import { createStore, applyMiddleware , compose} from 'redux';
// import createSagaMiddleware from "redux-saga";
import allReducers from './reducers/index';
// import sagas from "./sagas";
import thunk from 'redux-thunk';

// import {getFromStorage} from './functions/utils'
// const sagaMiddleware = createSagaMiddleware();

// const middlewares = [sagaMiddleware];

export function configureStore() {
    // const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
    const store = createStore(
        allReducers, applyMiddleware(thunk)
    );
    

    return store;
}


